import React, { useEffect } from 'react';

import { useTranslation } from 'react-i18next';

import { bemCssModules, getTestId } from '@utils';
import { useTimer } from '@utils/hooks';

import { useStore, loginActions } from '@modules';

import style from './ResendCode.scss';

const cn = bemCssModules(style, 'ResendCode');
const ti = getTestId('ResendCode');

export type TResendCode = {
  disabled?: boolean;
  isLoading?: boolean;
  timeout?: number;
  onResend(): void;
  id: string;
};

const ResendCode: CustomFC<TResendCode> = props => {
  const { className, disabled, timeout = 0, onResend, id, isLoading } = props;

  const { t } = useTranslation();
  const [, dispatch] = useStore();

  const { counter, restart } = useTimer({ initialCounter: timeout });

  const handleResend = () => onResend();

  useEffect(() => {
    if (!isLoading) restart();
  }, [isLoading]);

  useEffect(() => {
    dispatch(loginActions.updateTimeout(counter));
  }, [counter]);

  return (
    <div className={cn(null, [className])}>
      {counter > 0 ? (
        <p className={cn('value')}>{t(`public.get_new_code`, { counterVal: counter })}</p>
      ) : (
        <button
          className={cn('resend', ['link'])}
          type="button"
          id={id}
          data-testid={ti('button')}
          onClick={handleResend}
          disabled={disabled || isLoading}
        >
          {t('public.resend')}
        </button>
      )}
    </div>
  );
};

export default ResendCode;
